import React, { FC, useContext } from "react"
import { useSelector } from "react-redux"

import { getProduct } from "@/onboarding/features/product/selectors"
import { TenderStatuses } from "@/onboarding/features/product/models/Product"
import AuthDescriptorContext from "@/auth_descriptor/Context"

const Status: FC = () => {
  const { tenderStatus, awardedCompany } = useSelector(getProduct)
  const authDescriptor = useContext(AuthDescriptorContext)

  const operatorNameNode =
    authDescriptor.isCruiseLineUi && awardedCompany?.operatorProfileId ? (
      <a href={`/onboarding/operator_profiles/${awardedCompany.operatorProfileId}`}>
        {awardedCompany.name}
      </a>
    ) : (
      awardedCompany?.name
    )

  switch (tenderStatus) {
    case TenderStatuses.DRAFT:
      return <span className="text-warning">Draft</span>
    case TenderStatuses.READY_FOR_BIDS:
      return <span className="text-info">Ready for Bids</span>
    case TenderStatuses.BIDS_REQUESTED:
      return <span className="text-info">Bids Requested</span>
    case TenderStatuses.BIDDING_EXPIRED:
      return <span className="text-danger">Bidding Expired</span>
    case TenderStatuses.BIDDING_CLOSED:
      return <span className="text-warning">Bidding Closed</span>
    case TenderStatuses.AWARDED_TO_OPERATOR:
      return <span className="text-success">{operatorNameNode}</span>
    case TenderStatuses.CANCELLED:
      return <span className="text-danger">Cancelled (Previously for {operatorNameNode})</span>
    default:
      break
  }

  return null
}

export default Status
